import * as jwt from "jsonwebtoken";
import LogOut from "function/LogOut";

/* 회원 비회원 token 값 체크 */
export const PageTokenCheck = async (settings, router) => {
  const tokenValue = window.localStorage.getItem("aisoToken");
  if (tokenValue === "" || tokenValue === null) {
    settings.login = false;
    settings.email = "";
    settings.name = "";
    settings.photo = "";
    settings.uid = "";
    // window.localStorage.removeItem("aisoToken");
    router.push("/user/market");
    console.log("no login");
  } else {
    /* 만료된 토큰인지 체크해야함 */
    // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
    jwt.verify(tokenValue, process.env.SECRET_CODE, (error, decoded) => {
      console.log("PageTokenCheck");
      if (error) {
        /* 만료된 토큰임. token 삭제하기 */
        // window.localStorage.removeItem("aisoToken");
        LogOut(settings);
        router.push("/user/market");
      } else {
        const { email, name, uid } = decoded;
        settings.login = true;
        settings.email = email;
        settings.name = name;
        settings.uid = uid;
        const setTokenValue = jwt.sign({ email, name, uid }, process.env.SECRET_CODE, {
          expiresIn: "1d",
        });
        window.localStorage.setItem("aisoToken", setTokenValue);
        if (router && router.asPath === "/") {
          router.push("/user/market");
        } else {
          router.push(router.asPath);
        }
      }
    });
  }
};
